import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import GalleryViewer from '../partials/GalleryViewer';

import styles from '../../../styles/modals/gallery-modal.module.scss';

const propTypes = {
    images: PropTypes.arrayOf(AppPropTypes.image),
    image: AppPropTypes.image,
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    images: null,
    image: null,
    className: null,
};

const GalleryModal = ({ images, image, className, onClose, visible }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.visible]: visible,
            },
        ])}
    >
        <div className={styles.inner}>
            <GalleryViewer
                images={images}
                image={image}
                className={styles.viewer}
                onClickClose={onClose}
                fit="contain"
            />
        </div>
    </div>
);
GalleryModal.propTypes = propTypes;
GalleryModal.defaultProps = defaultProps;

export default GalleryModal;
